import React, { useState } from 'react';
import { ChoiceDetail, spellDetail } from '../components/LevelOneChoices';
import SpellChoiceTile from '../components/SpellChoiceTile';

/**
 * The cantrips and spells a new level adds, chosen through each spell's details. Optional: anything left is chosen on the
 * Spells page. `room` comes from levelUpSpellRoom; `onChange` reports `{ cantrips, spells }` as spell ids.
 */
export default function LevelUpSpellChoice({ room, picks, onChange }) {
  const [viewing, setViewing] = useState(null);
  const sections = [
    { key: 'cantrips', label: 'New cantrips', ...room.cantrips },
    { key: 'spells', label: 'New spells', ...room.spells },
  ].filter((section) => section.open > 0 && section.options.length);
  const section = viewing && sections.find(({ key }) => key === viewing.key);
  const spell = section?.options.find(({ spellId }) => spellId === viewing.spellId);
  const chosen = section ? picks[section.key] : [];
  return <div className="levelup-choice" role="group" aria-label="Spells">
    <p className="levelup-choice__hint">Choose what this level adds. Optional now: you can also choose them on the Spells page.</p>
    {sections.map(({ key, label, open, options }) => {
      const levels = [...new Set(options.map(({ level }) => Number(level)))];
      return <div key={key} className="mb-2" role="group" aria-label={label}>
        <span className="form-label">{label} · {picks[key].length} of {open}</span>
        {levels.map((level) => <div key={level} className="mb-2">
          {key === 'spells' && <strong className="d-block mb-1">Level {level}</strong>}
          <div className="levelup-spell-tiles">{options.filter((option) => Number(option.level) === level).map((option) => (
            <SpellChoiceTile key={option.spellId} spell={option} selected={picks[key].includes(option.spellId)} onClick={() => setViewing({ key, spellId: option.spellId })} />
          ))}</div>
        </div>)}
      </div>;
    })}
    {spell && <ChoiceDetail detail={spellDetail(spell)} selected={chosen.includes(spell.spellId)} full={chosen.length >= section.open} onClose={() => setViewing(null)}
      onConfirm={() => { onChange({ ...picks, [section.key]: chosen.includes(spell.spellId) ? chosen.filter((id) => id !== spell.spellId) : [...chosen, spell.spellId] }); setViewing(null); }}/>}
  </div>;
}
